import React from 'react'
import styled from 'styled-components'
import media from '../../../styles/media'

const InputWrapper = styled.input`
  display: table-cell;
  width: 100%;

  background: transparent;
  border: none;
  border-bottom: 2px solid #fbf6f3;

  padding-bottom: 0.5em;

  opacity: 0.6;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 3.6px;
  text-align: left;
  color: #ffffff;

  &:focus {
    outline: none;
    border-bottom: 2px solid #38abe0;
  }
  &::placeholder {
    color: #ffffff;
  }

  ${media.md`
  font-size: 18px;
`};
`

function Input({ placeholder, onChange, value, onKeyPress }) {
  return (
    <div>
      <InputWrapper
        placeholder={placeholder}
        type="text"
        onChange={onChange}
        value={value}
        onKeyPress={onKeyPress}
      />
    </div>
  )
}

export default Input



// WEBPACK FOOTER //
// ./src/components/step/input/input.js